import React from "react";
import "./RadioButtonGroup.scss";
import { Controller } from "react-hook-form";
import InputError from "../InputError";
import { RadioButton } from "../RadioButton/RadioButton";

interface RadioButtonGroupProps {
  name: string;
  control: any;
  label?: string;
  options: any;
}

export const RadioButtonGroup: React.FC<RadioButtonGroupProps> = (props: RadioButtonGroupProps) => {
  const { name, control, label, options } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <div className="radiobutton__container">
            {label && (
              <label className="radiobutton__label" htmlFor={name}>
                {label}
              </label>
            )}
            <div className="radiobutton__container-inner">
              {options.map((x, index) => {
                return (
                  <RadioButton
                    label={x.label}
                    index={index}
                    key={name + index}
                    name={name}
                    error={!!error}
                    value={x.value}
                    onChange={field.onChange}
                    checked={field.value === x.value}
                  />
                );
              })}
            </div>
            {!!error && <InputError>{error.message}</InputError>}
          </div>
        );
      }}
    />
  );
};
